import React from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { useQuery } from "@apollo/client";
import { GET_IMAGE_WITH_DIAMS, tokenOptions } from "../../backend/graphql";
import DiamondAnalysisView from "./DiamondAnalysisView";
import useDocumentTitle, { stoneName } from "../widgets/useDocumentTitle";

const AnalysisFromImage = () => {
  const { id } = useParams();
  const token = useAppSelector((state) => state.auth.token);
  const { loading, error, data } = useQuery(GET_IMAGE_WITH_DIAMS, {
    ...tokenOptions(token),
    variables: { take: 100, skip: 0, filter: 'iD == "' + id + '"' },
  });

  useDocumentTitle(
    stoneName(data?.images?.items[0]?.diamond),
    "Image analysis",
  );

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!id) return <p>Not found!</p>;

  const foundImage = data?.images?.items[0];
  const diamond = foundImage?.diamond;
  // The picture to analyse is the one the route points at.
  const image = foundImage && { id, calibration: foundImage.calibration };

  return <DiamondAnalysisView diamond={diamond} image={image} />;
};

export default AnalysisFromImage;
